import React, { useMemo, useState } from "react";

import { useTranslation } from "core/hooks/useTranslation";
import useDevice from "core/hooks/useDevice";
import useDate from "core/hooks/useDate";

import { Radio } from "antd";
import { DatePicker } from 'antd';

import { Row, Col } from "core/ui-kit/layout";
import Form from "core/ui-kit/form";
import Icon from "core/ui-kit/icon";

import { COMMISSION_TYPE, COMMISSION_TYPE_TRANSLATIONS } from "core/constants/commission/type";
import { COMMISSION_ADD_FIELDS } from "../../constants";

import FormRulesBuilder from "core/helpers/common/formRulesBuilder";

const Filters = ({
    formInstance,
    hideDetails,
    onFormValuesChange,
    availableCommissions
}) => {
    const { t } = useTranslation();
    const { isMobile } = useDevice();
    const { dateService } = useDate();

    const [selectedCommissionType, setSelectedCommissionType] = useState("");

    const now = new Date();
    const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);

    const onChangeRadioGroup = (event) => {
        setSelectedCommissionType(event.target.value);

        formInstance.setFieldsValue({
            [COMMISSION_ADD_FIELDS.COMMISSION]: null,
        });

        setTimeout(() => {
            onFormValuesChange(null, formInstance.getFieldsValue())
        }, 0)

        hideDetails();
    }

    const commissionsOptions = useMemo(
        () => {
            let data = [...availableCommissions];
            if (selectedCommissionType) {
                data = data.filter(res => res.type === selectedCommissionType);
            }

            return data.map((item) => {
                return {
                    text: item.name,
                    value: item.id,
                }
            })
        }, [selectedCommissionType, availableCommissions]
    );

    const commissionTypeOptions = useMemo(() => {
        return [
            { value: "", text: t('backoffice.common.all') },
            ...Object.values(COMMISSION_TYPE).map(type => ({ value: type, text: t(COMMISSION_TYPE_TRANSLATIONS[type]) }))
        ]
    }, [t])

    const colSpan = isMobile ? { span: 24 } : { span: 12 };

    const initialValues = {
        [COMMISSION_ADD_FIELDS.COMMISSION]: null,
        [COMMISSION_ADD_FIELDS.START_AND_END_DATE]: [dateService.makeUtcDateToLocal(oneHourLater), null]
    };

    return (
        <div className="rt--commissions-filters rt--pb-8">
            <Form 
                form={formInstance} 
                onValuesChange={onFormValuesChange}
                initialValues={initialValues}
            >
                <Row gutter={[16, 0]}>
                    <Col span={24}>
                        <Radio.Group
                            value={selectedCommissionType}
                            onChange={onChangeRadioGroup}
                        >
                            <div className="rt--flex rt--mb-16">
                                {
                                    commissionTypeOptions.map((item) => {
                                        return (
                                            <Radio value={item.value} key={item.value}>
                                                {item.text}
                                            </Radio>
                                        )
                                    })
                                }
                            </div>
                        </Radio.Group>
                        
                    </Col>
                    <Col {...colSpan}>
                        <Form.Select
                            name={COMMISSION_ADD_FIELDS.COMMISSION}
                            label={t('backoffice.commissionplans.commission')}
                            placeholder={`${t('backoffice.common.select')} ${t('backoffice.commissionplans.commission')}`}
                            options={commissionsOptions}
                            search={true}
                            rules={
                                new FormRulesBuilder(t).required().build()
                            }
                        />
                    </Col>
                    <Col {...colSpan}>
                        <Form.Item
                            name={COMMISSION_ADD_FIELDS.START_AND_END_DATE}
                            label={`${t('backoffice.commissionplans.startAndEndTime')} *`}
                            rules={
                                new FormRulesBuilder(t).required({whitespace: false}).build()
                            }
                        >
                            <DatePicker.RangePicker
                                format={`${dateService.getFormat(false)} HH:00`}
                                showTime={{
                                    format: "HH"
                                }}
                                allowEmpty={[false, true]}
                                disabledDate={d => dateService.isBefore(d, dateService.getNow())}
                                className="rt--datepicker rt--table-datepicker-search-with-time"
                                dropdownClassName="rt--datepicker-popup rt--datepicker-withtime-popup rt--datepicker-only-hours"
                                suffixIcon={<Icon name="date" />}
                                separator={<div className='rt--table-timepicker-separator' />}
                                showToday={true}
                                inputReadOnly={isMobile}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default Filters;